import Header from '@/components/pages/Header'
import Maps from '@/pages/Maps.vue'
import Garage from '@/pages/Garage.vue'
import Broadcast from '@/pages/Broadcast.vue'
import Contracts from '@/pages/Contracts.vue'
import { createWebHistory, createRouter } from 'vue-router'

const routes = [
  {
    path: '/bot/:id(\\d+)/maps',
    name: 'maps',
    components: { default: Maps, header: Header }
  },
  {
    path: '/bot/:id(\\d+)/broadcast',
    name: 'broadcast',
    component: Broadcast
  },
  {
    path: '/garage',
    name: 'garage',
    components: { default: Garage, header: Header }
  },
  {
    path: '/cave/contracts',
    name: 'contractSearch',
    components: { default: Contracts, header: Header }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
export default router
